export const SIZE_UNITS = {
    SQ_FT: 'sq ft',
    ACRES: 'acres',
};

export const showSize = (size, sizeUnits) => {
    const spotSize = parseFloat(size);
    if (SIZE_UNITS[sizeUnits] === SIZE_UNITS.ACRES) {
        if (spotSize < 1) {
            return `${spotSize} acres`;
        }
        if (spotSize == 1) {
            return '1 acre';
        }
        if (spotSize > 1 && spotSize < 10) {
            return `${Math.round(spotSize * 10) / 10} acres`;
        }
        if (spotSize >= 10) {
            return `${parseInt(spotSize)} acres`;
        }
    } else {
        return `${spotSize} ${SIZE_UNITS[sizeUnits] ? SIZE_UNITS[sizeUnits] : 'acres'}`;
    }
};
